import { useOfflineSync } from '../hooks/useOfflineSync';

export function SyncStatus() {
  const {
    pendingCount,
    failedCount,
    isSyncing,
    lastSyncAt,
    isOnline,
    syncNow,
  } = useOfflineSync();

  if (pendingCount === 0 && failedCount === 0 && !isSyncing && isOnline) {
    return null;
  }

  const formatTime = (ts: number | null) => {
    if (!ts) return 'Nunca';
    const diff = Date.now() - ts;
    const m = Math.floor(diff / 60000);
    if (m < 1) return 'Ahora';
    if (m < 60) return `Hace ${m} min`;
    const h = Math.floor(m / 60);
    if (h < 24) return `Hace ${h}h`;
    return new Date(ts).toLocaleDateString('es-MX');
  };

  const hasPending = pendingCount > 0 || failedCount > 0;

  return (
    <div
      className="fixed left-4 right-4 z-40 bg-white border border-slate-200 rounded-xl shadow-lg px-4 py-3"
      style={{ bottom: 'calc(5.5rem + env(safe-area-inset-bottom))' }}
    >
      <div className="flex items-center gap-3">
        <div
          className={`w-9 h-9 rounded-lg flex items-center justify-center text-lg flex-shrink-0 ${
            !isOnline
              ? 'bg-slate-100'
              : failedCount > 0
              ? 'bg-red-50'
              : isSyncing
              ? 'bg-amber-50'
              : 'bg-primary/10'
          }`}
        >
          {!isOnline ? '📴' : failedCount > 0 ? '⚠️' : isSyncing ? '⏳' : '🔄'}
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-slate-900 leading-tight">
            {!isOnline
              ? 'Sin conexión'
              : failedCount > 0
              ? `${failedCount} pendiente${failedCount === 1 ? '' : 's'} con error`
              : isSyncing
              ? 'Sincronizando…'
              : `${pendingCount} pendiente${pendingCount === 1 ? '' : 's'} de sincronizar`}
          </p>
          <p className="text-xs text-slate-500 leading-tight mt-0.5">
            {!isOnline
              ? 'Los cambios se guardan localmente'
              : failedCount > 0
              ? 'Revisa tu conexión e intenta de nuevo'
              : `Última sync: ${formatTime(lastSyncAt)}`}
          </p>
        </div>

        {isOnline && hasPending && !isSyncing && (
          <button
            onClick={syncNow}
            className="px-3 py-1.5 rounded-md bg-primary text-white text-xs font-semibold flex-shrink-0"
          >
            Sincronizar
          </button>
        )}
      </div>
    </div>
  );
}